///<reference path="../libs/info/imagelogic/Ajax.ts"/>
///<reference path="model/Weekly.ts"/>
///<reference path="model/Pinpoint.ts"/>
///<reference path="view/PinpointView.ts"/>

namespace app{
	import Pinpoint = app.model.Pinpoint;
	import Weekly = app.model.Weekly;
	import getJSON = info.imagelogic.Ajax.getJSON;
	import PinpointView = app.view.PinpointView;
	const pathToPinpoint:string = "../wnidata/wni/pinpoint.json";
	const pathToWeekly:string = "../wnidata/wni/week.json";

	export class PinpointDoc{
		constructor(){
			let dataArea = document.getElementById("dataArea"),
				location = dataArea.getAttribute("data-location");

			let pinpoint:Pinpoint = new Pinpoint(),
				weekly:Weekly = new Weekly();

			let view = new PinpointView();
			view.pinpoint = pinpoint;
			view.weekly = weekly;

			let promises = [
				getJSON(pathToPinpoint).then((data) => {
					pinpoint.parseData(data,location);
				}).catch((e) => {
					console.log("error pinpoint");
					console.log(e);
				}),
				getJSON(pathToWeekly).then((data)=>{
					weekly.parseData(data,location);
				}).catch((e) => {
					console.log("error weekly");
					console.log(e);
				})
			];

			Promise.all(promises).then(() => {
				// console.log("finish all");
				dataArea.innerHTML = view.makeData();
			}).catch((e) => {
				dataArea.innerHTML = view.makeError();
				console.log("something wrong");
				console.log(e);
			});
		}
	}
}